import { z } from 'zod'

import { DateZod, PilotePersonCompleteRecordZod, PilotePersonRecordZod } from '../../common'

import { PiloteVolunteerCompleteRecordZod, PiloteVolunteerRecordZod } from './records'

export const PiloteVolunteerZod = z.object({
  timestamp: DateZod.nullable().optional(),
  volunteer: PiloteVolunteerRecordZod,
  person: PilotePersonRecordZod,
})

export const PiloteVolunteerCompleteZod = z.object({
  timestamp: DateZod.nullable().optional(),
  volunteer: PiloteVolunteerCompleteRecordZod,
  person: PilotePersonCompleteRecordZod,
})
